import { BaseModel, attr } from "../../lib/itn-ui-kit/data";

export default class ProviderStatusHistoryModel extends BaseModel {
  static urlPath = "provider_status_histories";

  @attr("string") columnName;
  @attr("json") status;
  @attr("json") value;
  @attr("json") oldValue;
  @attr("json") newValue;
  @attr("string") startDate;
  @attr("string") endDate;
  @attr("json") updatedBy;
  @attr("json") createdBy;
  @attr("datetime") updatedAt;
  @attr("datetime") createdAt;
}
